import React, { useState ,useEffect} from "react";
import {Dropdown, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { PropagateLoader } from "react-spinners";
import ReactPaginate from "react-paginate";


interface ProgramInterface {
  id_program: number;
  id_site?: number;
  program_date?: string;
  site?: string;
  name?: string;
  client_name?: string;
  departure?: string;
  destination?: string;
  type?: string;
  observation?: string;
  status: string;
  nom_conducteur?: string;
  prenom_conducteur?: string;
  immatriculation_vehicule?: string;
}

interface ProgramTableProps {
  loading: boolean;
  programs: ProgramInterface[];
  selectedColumns: Record<string, boolean>;



  selectedDeadlines: string[];
  selectAll: boolean;
  handleSelectAllDrivers: (checked: boolean) => void;
  handleDeadlinesSelect: (DeadlineID: string) => void;

  copiedId?: string | null;
  copyToClipboard?: (text: string, id: string) => void;

  translate: (key: string) => string;

  //sorting controls
  sortColumn: string;
  sortOrder: "ASC" | "DESC";
  handleSortingColumn: (column: string) => void;
  

  handleShowNewDeadlineModal: () => void;
  //handleEditProgramModal: (program: ProgramInterface) => void;
  handleEditProgramModal: (program: any) => void;
  handleshowShowProgramModal: (id: number) => void;
  handleDeleteProgramModal: (id: number) => void;

  getStatusIcon: (status: string) => React.ReactNode;

  //pagination
  limit: number;
  total: number;
  pageCount: number;
  currentPage: number;
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handlePageClick: (data: any) => void;
  columnsMap: Record<string, string>;
  handleColumnChange: (col: string) => void;
  initialColumns: Record<string,boolean>;
  
  //search
  menuItems: string[];
  handleTypeSearch:(val:string)=>void;
  type:number;
  //typeSearch: string; 
  search: string;
  handleAdvancedSearch:(event:React.ChangeEvent)=>void;

}

const ProgramTable: React.FC<ProgramTableProps> = ({
loading,
  programs,
  selectedColumns,
  selectedDeadlines,
  selectAll,
  handleSelectAllDrivers,
  handleDeadlinesSelect,
  copiedId,
  copyToClipboard,
  translate,
  sortColumn,
  sortOrder,
  handleSortingColumn,
  handleShowNewDeadlineModal,
  handleEditProgramModal,
  handleshowShowProgramModal,
  handleDeleteProgramModal,
  getStatusIcon,
  limit,
  total,
  pageCount,
  currentPage,
  handleSelectChange,
  handlePageClick,
  columnsMap,
  handleColumnChange,
  initialColumns,
  menuItems,
  handleTypeSearch,
  type,
  //typeSearch: propTypeSearch,
  handleAdvancedSearch,
  search
}) => { 
  
   const id_user = localStorage.getItem("userid");

 // Manage UI state entirely locally
  const [localTypeSearch, setLocalTypeSearch] = useState(
    id_user === "1" ? translate("ID Program") : translate("Program Date")
  );

  const handleLocalTypeSelection  = (item: string) => {
    setLocalTypeSearch(item);
    handleTypeSearch(item);
  };


   const filteredMenuItems = [
  ...(id_user === "1" ? [translate("ID Program")] : []), // Show "ID Program" only for admin
  "Program Date",
  "Client",
  "Departure",
  "Destination",
  "Type",
  "Driver",
  "Vehicle",
  "Observation",
  "Status",
];

  return (
    
    <div className="row">
      <div
          className="col-md-4"
          style={{ margin: "0px 0px 10px 0px", padding: "10px" }}
        >
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <i
                  className="fas fa-chevron-down"
                  style={{ fontSize: "20px" }}
                ></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {filteredMenuItems.map((item, index) => ( 
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleLocalTypeSelection(item)}
                    eventKey={item}
                    active={localTypeSearch === item}
                    className={localTypeSearch === item ? "select-active" : ""}
                  >
                    {translate(item)}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <input
              type="text"
              placeholder={`by ${translate(localTypeSearch)}`}
              value={search}
              onChange={handleAdvancedSearch}
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="dataTables_length">
    <label style={{ marginLeft: "16px", marginBottom: "0" }}>
      {translate("Show")}
      <select
        className="custom-select custom-select-sm form-control form-control-sm ml-2"
        style={{ width: "66px" }}
        value={limit}
        onChange={handleSelectChange}
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
      </select>
    </label>
  </div>
  <Dropdown>
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              title="Display Columns"
            >
              <i className="las la-eye"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {Object.entries(columnsMap).map(([colKey, translation], idx) => (
                <Dropdown.Item
                  key={idx}
                  as="div"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns[colKey as keyof typeof initialColumns]}
                    onChange={() =>
                      handleColumnChange(colKey as keyof typeof initialColumns)
                    }
                  />
                  <span style={{ marginLeft: "10px" }}>{translate(translation)}</span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
</div>
    <Table className="dataTable" responsive>
      <thead className="bg-white text-uppercase">
        <tr className="ligth ligth-data">
          <th>
            <div className="form-check" style={{ paddingLeft: "0px" }}>
              <input
                className="form-check-input"
                type="checkbox"
                checked={selectAll}
                onChange={(e) => handleSelectAllDrivers(e.target.checked)}
              />
              <label className="form-check-label"></label>
            </div>
          </th>

          {/* Uncomment if needed */}
          {selectedColumns.id_program && id_user == "1" && (
            <th className="sorting" onClick={() => handleSortingColumn("id_program")}>{translate("ID")}</th>
          )}
          {selectedColumns.program_date && (
            <th className="sorting" onClick={() => handleSortingColumn("program_date")}>{translate("Program Date")}</th>
          )}
          {selectedColumns.site && (
            <th className="sorting" onClick={() => handleSortingColumn("site")}>{translate("Site")}</th>
          )}
          {selectedColumns.client_name && (
            <th className="sorting" onClick={() => handleSortingColumn("client_name")}>{translate("Client")}</th>
          )}
          {selectedColumns.departure && (
            <th className="sorting"onClick={() => handleSortingColumn("departure")}>{translate("Departure")}</th>
          )}
          {selectedColumns.destination && (
            <th className="sorting" onClick={() => handleSortingColumn("destination")}>{translate("Destination")}</th>
          )}
          {selectedColumns.type && (
            <th className="sorting" onClick={() => handleSortingColumn("type")}>{translate("Type")}</th>
          )}
          {selectedColumns.nom_conducteur && (
            <th className="sorting" onClick={() => handleSortingColumn("nom_conducteur")}>{translate("Driver")}</th>
          )}
          {selectedColumns.immatriculation_vehicule && (
            <th className="sorting" onClick={() => handleSortingColumn("immatriculation_vehicule")}>{translate("Vehicle")}</th>
          )}
          {selectedColumns.observation && (
            <th className="sorting" onClick={() => handleSortingColumn("observation")}>{translate("Observation")}</th>
          )}
          {selectedColumns.status && (
            <th className="sorting" onClick={() => handleSortingColumn("status")}>{translate("Status")}</th>
          )}
          <th>{translate("Action")}</th>
        </tr>
      </thead>
      <tbody className="light-body">
        {loading ? (
          <tr style={{ textAlign: "center" }}>
            <td className="text-center" colSpan={10}>
              <p>
                <PropagateLoader color={"#123abc"} loading={loading} size={20} />
              </p>
            </td>
          </tr>
        ) : Array.isArray(programs) && programs.length > 0 ? (
          programs.map((program, index) => (
            <tr key={index}>
              <td>
                <div className="form-check form-check-inline">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`checkbox-${program.id_program}`}
                    checked={selectedDeadlines.includes(program.id_program?.toString() || "")}
                    onChange={() => handleDeadlinesSelect(program.id_program?.toString() || "")}
                  />
                  <label htmlFor={`checkbox-${program.id_program}`} className="mb-0"></label>
                </div>
              </td>
              {selectedColumns.id_program && id_user == "1" && <td>{program.id_program}</td>}
              {selectedColumns.program_date && (
                <td>{program.program_date ? moment(program.program_date).format("DD-MM-YYYY") : ""}</td>
              )}
              {selectedColumns.site && <td>{program.name || ""}</td>}
              {selectedColumns.client_name && <td>{program.client_name || ""}</td>}
              {selectedColumns.departure && <td>{program.departure || ""}</td>}
              {selectedColumns.destination && <td>{program.destination || ""}</td>}
              {selectedColumns.type && <td>{program.type || ""}</td>}
              {selectedColumns.nom_conducteur && (
                <td>{`${program.nom_conducteur || ""} ${program.prenom_conducteur || ""}`}</td>
              )}
              {selectedColumns.immatriculation_vehicule && (
                <td
                  id={`vehicle-${program.id_program}`}
                  style={{
                    cursor: copyToClipboard ? "pointer" : "default",
                    position: "relative",
                  }}
                  title={translate("Click to copy")}
                  onClick={() => {
                    if (copyToClipboard && program.immatriculation_vehicule && program.id_program?.toString()) {
                      copyToClipboard(program.immatriculation_vehicule, program.id_program.toString());
                    }
                  }}
                >
                  <span
                    style={{
                      color: copiedId === program.id_program?.toString() ? "#28a745" : "#007bff",
                    }}
                  >
                    {program.immatriculation_vehicule || ""}
                  </span>
                  {copiedId === program.id_program?.toString() && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        padding: "2px 5px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {translate("Copied")}
                    </span>
                  )}
                </td>
                
              )}
              {selectedColumns.observation && <td>{program.observation || ""}</td>}
              {selectedColumns.status && (
                <td>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {getStatusIcon(program.status)}
                  </div>
                </td>
              )}
              <td className="text-center">
                <div className="d-flex justify-content-center align-items-center list-action">
                  {/*<Link
                    to={``}
                    className="badge bg-secondary text-white mr-2"
                    title={translate("Add program")}
                    onClick={handleShowNewDeadlineModal}
                  >
                    <i className="ri-add-line mr-0" style={{ fontSize: "1.2em" }}></i>
                  </Link>*/}
                  <Link
                    to={``}
                    className="badge bg-success mr-2"
                    title={translate("Edit")}
                    //onClick={() => handleEditProgramModal(program.id_program)}
                    onClick={() => handleEditProgramModal(program)}
                  >
                    <i className="ri-pencil-line mr-0" style={{ fontSize: "1.2em" }}></i>
                  </Link>
                  <Link
                    to={``}
                    className="badge bg-primary mr-2"
                    title={translate("Detail")}
                    onClick={() => handleshowShowProgramModal(program.id_program)}
                  >
                    <i className="las la-eye" style={{ fontSize: "1.2em" }}></i>
                  </Link>
                  <Link
                    to={``}
                    className="badge bg-danger mr-2"
                    title={translate("Delete")}
                    onClick={() => handleDeleteProgramModal(program.id_program)}
                  >
                    <i className="las la-trash" style={{ fontSize: "1.2em" }}></i>
                  </Link>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr style={{ textAlign: "center" }}>
            <td colSpan={Object.keys(selectedColumns).length || 10}>No data available</td>
          </tr>
        )}
      </tbody>
    </Table>
    <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <span>
                {translate("Displaying")} {programs.length} {translate("on")}{" "}
                {total}
              </span>
            </div>
            </div>
    <ReactPaginate
  previousLabel={translate("previous")}
  nextLabel={translate("next")}
  breakLabel={"..."}
  pageCount={pageCount}
  marginPagesDisplayed={2}
  pageRangeDisplayed={3}
  onPageChange={handlePageClick}
  containerClassName={"pagination justify-content-end"}
  pageClassName={"page-item"}
  pageLinkClassName={"page-link"}
  previousClassName={"page-item"}
  previousLinkClassName={"page-link"}
  nextClassName={"page-item"}
  nextLinkClassName={"page-link"}
  breakClassName={"page-item"}
  breakLinkClassName={"page-link"}
  activeClassName={"active"}
  forcePage={currentPage - 1}
/>
    </div>
  );
};

export default ProgramTable;
